import React, { FC } from 'react';
import Co2Information from '@/components/pages/Co2Information/Co2Information/Co2Information';

export const Co2InformationPage: FC = () => {
  return <Co2Information />;
};
